import * as React from 'react'

type Props = {
  id: string
  checked?: boolean
  value?: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export function Checkbox({id, checked = false, value, onChange}: Props): React.ReactElement {
  return (
    <label htmlFor={id} className="flex items-center gap-2 cursor-pointer">
      <input
        id={id}
        type="checkbox"
        value={value}
        checked={checked}
        onChange={onChange}
        className="h-4 w-4 rounded border border-input accent-primary"
      />
    </label>
  )
}
